<template>
    <v-expand-transition>
        <v-card
            class="mx-auto"
            width="400"            
            v-show="expand"
            light                        
        >    
            
            <v-toolbar
                color="primary white--text"
                light
            >
                <v-toolbar-title>Select Subject Class</v-toolbar-title>
            </v-toolbar>
            <v-card-text
                style="height: 60vh; overflow-y: auto"
            >
                <v-list 
                    light                
                >
                    <v-list-item-group v-model="lessonSelected">
                        <v-list-item
                            v-for="(item, i) in lessons"
                            :key="i"
                            @click="setLesson(item)"
                        >
                            <v-list-item-avatar>
                                <v-icon :class="avatarClass">
                                    mdi-account-group
                                </v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ item.lesson }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-card-text>
        </v-card>
    </v-expand-transition>         
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {    
    mounted: function(){
        if(!this.admin)
        this.getLessons();
    },

    data: () => ({
        lessons: [],
        lessonSelected: {lesson: '', className: '', subjectCode: '', subjectTitle: ''},
        open: true,
        clear: true,       
        records: [],        
    }),
   
    computed: {
        ...mapGetters({            
            id: 'auth/getEmployeeId',
            lessonRecords: 'termReports/getLessons',
            expand: 'termReports/getExpandLessonOptions',
            studentsTotal: 'termReports/getSubjectStudentsTotal',
            studentsRegistered: 'termReports/getSubjectStudentsRegistered',
            studentsMarksEntered: 'termReports/getSubjectStudentsMarksEntered',
            admin: 'auth/getAdmin',                            
        }),
        primary(){
            return 'primary';
        },
        avatarClass(){
            return  'primary white--text';
        } 
    },
    methods: {
        ...mapActions({
           getLessonRecords: 'termReports/getLessons',
           getStudents: 'termReports/getStudents',           
        }),

        ...mapMutations({
            setLessonSelected: 'termReports/setLessonSelected',
            setExpand: 'termReports/setExpandLessonOptions',
            // markSheetLoading: 'termReports/setMarkSheetLoading',
            markSheetOverlay: 'termReports/setMarkSheetOverlay',
            table2Records: 'termReports/setTable2Records',
        }),

        async setLesson(lesson){
            this.setLessonSelected(lesson);
            this.setExpand(false);
            
            setTimeout(() => {
                this.$emit('loading', true);
            }, 700) 
            try {
                await this.getStudents(this.id);
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }                                  
            setTimeout(() => {
                // this.markSheetLoading(true);
                console.log('loading..')
                this.$emit('loading', false);
            }, 700)
        },

        async getLessons(){
            // this.markSheetLoading(false);
            this.$emit('loading', true);            

            try {
                await this.getLessonRecords(this.id);  
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }                    
            
            
            this.lessonRecords.forEach(lessonRecord =>{
                let subject = lessonRecord.subject.title;
                this.lessons.push({
                    lesson: lessonRecord.form_class_id + ' ' + subject,
                    className: lessonRecord.form_class_id,                    
                    subjectCode: lessonRecord.subject.id,
                    subjectTitle: subject,
                    formLevel: lessonRecord.form_class.form_level,
                })
            });

            this.$emit('loading', false);
            
            this.$nextTick(() => {
                this.setExpand(true);
            })            
        },

    }
}
</script>